/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Word5Inputs */

const en_wc_vs_word5 = /** @type {(inputs: Wc_Vs_Word5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile apps for iOS and Android, and enterprise support and administration.`)
};

/**
* | output |
* | --- |
* | "Mobile apps for iOS and Android, and enterprise support and administration." |
*
* @param {Wc_Vs_Word5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_word5 = /** @type {((inputs?: Wc_Vs_Word5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Word5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_word5(inputs)
});
export { wc_vs_word5 as "wc.vs.word5" }